import { Link } from 'react-router-dom'
import Imgnotfound  from '../../statics/img/not_found.jpg'
const Notfound = () => {
  return (
    <div className="c-not-found">
      <img className="c-not-found__img" src={Imgnotfound} alt="not found img" />
      <span className="c-not-found__text">Seems there is nothing here, the page does not exist.</span>
      <Link to='/' className="c-not-found__button">Return Home</Link>
    </div>
  )
}

export default Notfound